import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  makeStyles,
  Button,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  Container,
  Card,
  CardContent,
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@material-ui/core";
import { Multiselect } from "multiselect-react-dropdown";

import { URLS } from './URLS';

const useStyles = makeStyles((theme) => ({
  container: {
    alignContent: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "100% !important",
  },
  button_general: {
    margin: theme.spacing(1),
    background: "#2196f3",
    color: "#ffffff",
    "&:hover": {
      background: "#1d72d2",
    },
  },
    card: {
    marginTop: theme.spacing(2),
  },
  tableContainer: {
    width: "100%",
  },
  table: {
    width: "100%",
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: theme.palette.grey[200],
  },
  tableRow: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

function BuildMultiSelect({
  json_name,
  label,
  init_value,
  getError,
  list,
  onChange,
  singleSelect = false,
  active = true,
  etasindex = null,
}) {
  const [selected, setSelected] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    if (init_value) {
      setSelected(init_value);
    }
  }, [init_value]);

  function onSelect(selectedList, selectedItem) {
    setSelected(selectedList);
    onChange(selectedList, json_name, etasindex);
  }

  function onRemove(selectedList, removedItem) {
    setSelected(selectedList);
    onChange(selectedList, json_name, etasindex);
  }

  return (
    <React.Fragment>
      <InputLabel>{label}</InputLabel>
      <Multiselect
        options={list}
        selectedValues={selected}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue="name"
        autoComplete="new-password"
        disabled={!active}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </React.Fragment>
  );
}

function BuildSelectGeneral({
  label,
  list,
  init_value,
  externalSettter,
  extraExternalParams,
  active = true,
}) {
  const [val, setVal] = useState(999999);
  const classes = useStyles();

  useEffect(() => {
    if (init_value !== undefined) {
      setVal(init_value);
    }
  }, [init_value]);

  function handleChange(e) {
    setVal(e.target.value);
    externalSettter(e.target.value, extraExternalParams);
  }

  return (
    <FormControl className={classes.formControl}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={val}
        onChange={handleChange}
        disabled={!active}
        fullWidth
      >
        {list?.map((a) => (
          <MenuItem key={a.id} value={a.id}>
            {a.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}


function MissingsByUser({ missings }) {
  const classes = useStyles();

  // Group and count unique dates per user
  const grouped = missings.reduce((acc, { user, date }) => {
    if (!acc[user]) acc[user] = new Set();
    acc[user].add(date);
    return acc;
  }, {});

  const rows = Object.entries(grouped)
    .map(([user, dates]) => ({
      user,
      days: dates.size,
    }))
    .sort((a, b) => b.days - a.days);

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Missing Days by User
        </Typography>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>User</TableCell>
                <TableCell className={classes.headerCell} align="right">
                  Missing Days
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.user} className={classes.tableRow}>
                  <TableCell>{row.user}</TableCell>
                  <TableCell align="right">{row.days}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}


function MissedTasksPanel({ user, lists }) {
  const classes = useStyles();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [region, setRegion] = useState(999999);

  const [initMissings, setInitMissings] = useState([]);

  function handleSetRegion(val) {
    setRegion(val);
  }

  function handleSubmit(e) {
    console.log({ startDate, endDate, region });

    fetch(URLS.aj_get_missed_tasks, {
                method: "POST",
                body: JSON.stringify({
                    startDate: startDate,
                    endDate: endDate,
                    region: region
                })
            }).then(res=>res.json()).then(response => {
                setInitMissings(response.missings);
                

            })

  }

  return (
    <Container maxWidth="md" className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <BuildSelectGeneral
                label="Region"
                list={lists.regions}
                init_value={region}
                externalSettter={handleSetRegion}
                extraExternalParams={null}
              />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            inputProps={{
              min: startDate,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            onClick={handleSubmit}
            className={classes.button_general}
            fullWidth
          >
            GET!
          </Button>
        </Grid>
        <Grid item xs={12}>
        {initMissings && 
            <MissingsByUser missings={initMissings} />
        }
        </Grid>
        
        
      </Grid>
    </Container>
  );
}

export { MissedTasksPanel };
